import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "../../material/material.module";
import { ProfileDetailComponent } from "./profile-detail/profile-detail.component";
import { IndiviualPropertyOwnerComponent } from "./indiviual-property-owner/indiviual-property-owner.component";
import { PropertyMgmtCoComponent } from "./property-mgmt-co/property-mgmt-co.component";
import { BBHotelMotelComponent } from "./b-bhotel-motel/b-bhotel-motel.component";
import { RegisterStepperModule } from "../register/register-stepper.module";
import { ChangePasswordComponent } from "./change-password/change-password.component";
import { SecurityModule } from "../../security/security.module";
import { NotificationComponent } from "../../shared/notification/notification.component";
import { RouterLink } from "@angular/router";
import { ToasterContainerComponent } from "../../shared/toaster/toaster-container.component";
import { ToasterComponent } from "../../shared/toaster/toaster.component";

@NgModule({
    declarations: [
        ProfileDetailComponent,
        IndiviualPropertyOwnerComponent,
        PropertyMgmtCoComponent,
        BBHotelMotelComponent,
        ChangePasswordComponent,
    ],
    imports: [
      CommonModule,
      RouterLink,
      MaterialModule,
      FormsModule,
      ReactiveFormsModule,
      RegisterStepperModule,
      SecurityModule, 
    ]
  })

export class ProfileModule{};